import { useForm, Controller } from "react-hook-form";
import { Form, Input, InputGroup } from "reactstrap";
import styled from "styled-components";
import { ClearAllIcon, SearchIcon } from "../utils/icon.utils";
import Button from "./Button";

export default function Search({
  name = "",
  onSubmit,
  placeholder = "Search...",
  type = "text",
  defaultValue = "",
  isSearched,
  handleClear
}) {
  const { control, watch, reset, setValue, handleSubmit } = useForm();

  const chassis = watch("chassis");

  if (Number(chassis) < 0) {
    setValue("chassis", 0);
  }

  const onClear = () => {
    handleClear();
    reset();
  };

  return (
    <FormContainer onSubmit={handleSubmit(onSubmit)}>
      <InputGroup size="sm">
        <Controller
          name={name}
          control={control}
          rules={{ min: 0 }}
          defaultValue={defaultValue}
          render={({ field }) => <Input {...field} type={type} placeholder={placeholder} />}
        />

        <Button type="submit" icon={SearchIcon} />
        {isSearched && <Button onClick={onClear} className="ms-1 px-2" icon={ClearAllIcon} />}
      </InputGroup>
    </FormContainer>
  );
}

const FormContainer = styled(Form)`
  .form-control {
    height: 30px;
  }
`;
